
import {Component, Vue, Watch} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import FromUserEditor from '@/views/module-from-user-manage/from-user-editor.vue'
import UserBillInfo from '@/model/modules/UserBillInfo'
import UserInfoService from '@/service/modules/UserInfoService'
import DateUtil from '@/utils/DateUtil'

@Component({
  components: {FromUserEditor}
})
export default class ModuleBillManage extends Vue {
  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '数据ID', value: 'id'},
    {text: '变动日期', value: 'createAt'},
    {text: '账单类型', value: 'type'},
    {text: '变动金额', value: 'price'},
    {text: '变动后结果', value: 'balance'},
    {text: '备注', value: 'remark'}
  ]

  dateUtil: DateUtil = DateUtil

  queryLikeResult: BasePageableInfo<UserBillInfo> = new BasePageableInfo<UserBillInfo>()
  queryType: string = 'userName'
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  mounted() {
    this.refreshAllData()
  }

  @Watch('pageNum')
  onPageNumChanged() {
    this.refreshAllData()
  }

  @Watch('pageSize')
  refreshAllData() {
    this.listLoadingState = true
    UserInfoService.getCurrentUserBillInfoList({
      sortName: 'createAt',
      sortOrder: 'desc',
      userId: UserInfoService.getCurrentUserId()
    }, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<UserBillInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }
}
